import * as React from "react";

import { UILocation } from "@1js/acui-common";
import { AppFontPickerProps } from "@1js/acui-font-picker";
import { AppIcons } from "@1js/acui-icons";

import { RibbonFontPicker } from "../../Ribbon";

export function getDefaultFontPickerRenderer(appIcons: AppIcons) {
  return (props: AppFontPickerProps) => (
    <RibbonFontPicker
      {...props}
      downChevronIcon={appIcons.downChevron}
      location={props.location || UILocation.Ribbon}
    />
  );
}
